<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-card flat min-height="60vh">
      <v-layout wrap justify-center px-3>
        <v-flex xs12 sm12>
          <v-layout wrap pt-3>
            <v-flex xs12 align-self-center text-center pb-4>
              <span class="headds"
                >Selling Category
                <span>
                  <v-dialog
                    :retain-focus="false"
                    v-model="dialog"
                    persistent
                    max-width="600px"
                    :key="dialog"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        style="font-family: poppinsmedium"
                        outlined
                        small
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Edit Category
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">Add Category</span>
                      </v-card-title>
                      <v-card-text>
                        <!-- <v-container> -->
                        <v-layout wrap>
                          <v-flex xs12 pt-5>
                            <v-select
                              v-model="extraData.category"
                              :items="categoryList"
                              multiple
                              prepend-icon="mdi-food"
                              item-text="name"
                              item-value="_id"
                              color="#B1B1B1"
                              hide-details=""
                              placeholder="Category"
                              label="Category"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="dialog = false"
                        >
                          Close
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="updateData()">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </span>
              </span>
            </v-flex>
            <v-flex
              xs6
              align-self-center
              lg3
              pt-5
              px-2
              v-for="(items, i) in categoryData"
              :key="i"
            >
              <v-card flat elevation="2">
                <v-layout wrap justify-start>
                  <v-flex xs3 align-self-center pl-2 text-center>
                    <v-list-item-avatar>
                      <v-img contain :src="mediaURL + items.icon"></v-img>
                    </v-list-item-avatar>
                  </v-flex>
                  <v-flex xs9 align-self-center text-left>
                    <span style="font-family: poppinsmedium">{{
                      items.name
                    }}</span>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 py-8>
          <v-divider></v-divider>
        </v-flex>
        <v-flex xs12 sm12>
          <v-layout wrap py-3>
            <v-flex xs12 align-self-center text-center pb-4>
              <span class="headds"
                >Product Type
                <span>
                  <v-dialog
                    :retain-focus="false"
                    v-model="dialog2"
                    persistent
                    max-width="600px"
                    :key="dialog2"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        style="font-family: poppinsmedium"
                        outlined
                        small
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Edit Product Type
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">Add Product Type</span>
                      </v-card-title>
                      <v-card-text>
                        <!-- <v-container> -->

                        <v-layout wrap>
                          <v-flex xs12 pt-5>
                            <v-select
                              v-model="extraData.type"
                              :items="productTypes"
                              multiple
                              prepend-icon="mdi-food"
                              item-text="title"
                              item-value="value"
                              color="#B1B1B1"
                              hide-details=""
                              placeholder="Product Type"
                              label="Product Type"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="dialog2 = false"
                        >
                          Close
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="updateData()">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </span>
              </span>
            </v-flex>
            <v-flex
              xs6
              align-self-center
              lg3
              pt-5
              px-2
              v-for="(items, i) in type"
              :key="i"
            >
              <v-card flat elevation="2">
                <v-layout pa-4 wrap justify-center>
                  <v-flex xs12 align-self-center text-center>
                    <!-- <v-list-item-avatar>
                      <v-img contain :src="mediaURL + items.icon"></v-img>
                    </v-list-item-avatar> -->
                    <span style="font-family: poppinsmedium">{{ items }}</span>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 py-8>
          <v-divider></v-divider>
        </v-flex>
        <v-flex xs12 sm12 text-center>
          <v-layout wrap py-3 justify-center>
            <v-flex xs12 align-self-center pb-4>
              <span class="headds">Charges </span>
            </v-flex>

            <v-flex xs6 align-self-center pt-5 px-2>
              <v-layout wrap>
                <v-flex xs12 text-center pb-5>
                  <v-checkbox
                    :ripple="false"
                    v-model="extraData.isPriceVary"
                    label="Product price may vary..?"
                    color="#FEBD08"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs8>
                  <v-text-field
                    prepend-icon="mdi-account-outline"
                    label="Parcel Charge"
                    v-model="extraData.parcelCharge"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs12 md4 py-4 pl-4>
                  <v-btn dark block color="#FEBD08" @click="updateData">
                    SAVE
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["categoryData", "type", "parcelChargeData", "isPriceVary", "catId"],

  data() {
    return {
      showSnackBar: false,
      msg: "",
      timeout: 3000,
      extraData: {
        category: [],
        type: [],
        uid: this.$route.query.seller,
        parcelCharge: null,
        isPriceVary: false,
      },

      categoryList: [],
      dialog: false,
      dialog2: false,

      productTypes: [
        {
          title: "Vegetarian",
          value: "Vegetarian",
        },
        {
          title: "Non-Vegetarian",
          value: "Non-vegetarian",
        },
        {
          title: "Eggetarian",
          value: "Eggetarian",
        },
      ],
    };
  },
  //   computed: {
  //     bankdata() {
  //       if (this.bank) {
  //         return this.bank;
  //       } else return {};
  //     },
  //   },
  mounted() {
    // console.log("catdata", this.categoryData)

      if (this.$route.query.Type == "foodSeller") {
    this.getCategoryList();
      }
      if (this.$route.query.Type == "grocerySeller") {
        this.getProductTypeList()
      }

    this.extraData.category = this.categoryData;
    this.extraData.type = this.type;
    this.extraData.parcelCharge = this.parcelChargeData;
    this.extraData.isPriceVary = this.isPriceVary;


  },
  methods: {
    updateData() {

         let getURL;
      if (this.$route.query.Type == "foodSeller") {
        getURL = "/admin/seller/edit";
      }
      if (this.$route.query.Type == "grocerySeller") {
        getURL = "/grocery/admin/seller/edit";
      }
      axios({
        method: "post",
        url: getURL,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.extraData,
      }).then((response) => {
        if (response.data.status) {
          this.$emit("stepper", {
            getData: true,
          });
          this.dialog2 = false;
          this.dialog = false;
          this.msg = "Details updated successfully";
          this.showSnackBar = true;
        } else {
          this.showSnackBar = true;
          this.msg = response.data.msg;
        }
        this.appLoading = false;
      });
    },
    getCategoryList() {
      this.flagg = false;
      this.appLoading = true;
      axios({
        url: "/category/list/" + this.catId._id,
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          itemId: this.$route.query.sub,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.categoryList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getProductTypeList() {
      this.appLoading = true;
      axios({
        url: "/grocery/category/list/62b16b36fdd907192c69f476",
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          itemId: this.$route.query.sub,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.categoryList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
